import { render } from "./CTACards.vue?vue&type=template&id=6cb7b7aa&scoped=true&ts=true"
import script from "./CTACards.vue?vue&type=script&lang=ts"
export * from "./CTACards.vue?vue&type=script&lang=ts"

import "./CTACards.vue?vue&type=style&index=0&id=6cb7b7aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb7b7aa"]])

export default __exports__